<template>
  <div class="wrapper" v-loading="ifLoading">
    <div class="contentContainer">
      <div class="totalDescribe">
        <div class="describe">
          <i class="el-icon-user-solid" style=""></i>
          <div class="name">
            <strong>{{ roleData.roleName }}</strong>
            <br />
            {{ roleData.roleDesc }}
          </div>
        </div>
        <div class="actSide">
          <el-button size="small" @click="editUserByRole(roleData)"
            >添加人员</el-button
          >
          <!-- <el-button size="small">编辑角色</el-button>
          <el-button size="small">停用角色</el-button>
          <el-button size="small">复制角色</el-button> -->
          <el-button size="small" @click="deleteRole">删除角色</el-button>
        </div>
      </div>
      <el-tabs v-model="activeName" type="card" @tab-click="getData">
        <el-tab-pane label="权限" name="power">
          <div class="treeContainer">
            <el-input
              style="margin-bottom: 20px"
              placeholder="搜索"
              v-model="filterText"
              clearable
            >
            </el-input>

            <el-tree
              :data="powerTree"
              show-checkbox
              node-key="id"
              :filter-node-method="filterNode"
              :props="{ label: 'title' }"
              ref="tree"
            >
            </el-tree>
            <br />
            <div style="display: flex; justify-content: flex-end">
              <el-button @click="submitPower" type="primary">保存</el-button>
            </div>
          </div>
        </el-tab-pane>
        <el-tab-pane label="成员列表" name="users">
          <el-table :data="userList" border style="width: 100%">
            <el-table-column
              prop="userName"
              label="姓名"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="groupName"
              label="部门"
              min-width="100"
            ></el-table-column
            ><el-table-column
              prop="createTime"
              label="添加时间"
              min-width="100"
            ></el-table-column
          ></el-table>
        </el-tab-pane>
      </el-tabs>
    </div>
    <el-dialog
      title="编辑使用该角色的用户"
      :visible.sync="userInRoleData.ifShow"
      append-to-body
      width="50%"
    >
      <el-form class="demo-form-inline" label-width="120px">
        <el-form-item label="角色名称">
          <el-input
            v-model="userInRoleData.roleName"
            placeholder="请输入角色名称"
            style="width: 300px"
            disabled
          ></el-input>
        </el-form-item>
        <el-form-item label="添加成员">
          <div class="tagBox">
            <el-tag
              :key="'user' + tag.id"
              v-for="tag in userInRoleData.users"
              closable
              :disable-transitions="false"
              @close="handleClose(tag)"
            >
              {{ tag.userName }}
            </el-tag>
            <el-autocomplete
              class="input-new-tag"
              size="small"
              v-model="userInRoleData.searchText"
              v-if="userInRoleData.inputVisible"
              :fetch-suggestions="userInputSearch"
              placeholder="请输入内容"
              ref="saveTagInput"
              @select="handleInputConfirm"
            >
              <template slot-scope="{ item }">
                <div class="name">{{ item.userName }}</div>
                <!-- <span class="addr">{{ item.address }}</span> -->
              </template>
            </el-autocomplete>

            <el-button
              v-else
              class="button-new-tag"
              size="small"
              @click="showInput"
              >+ 添加用户</el-button
            >
          </div>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="roleData.ifShow = false">取 消</el-button>
        <el-button type="primary" @click="submitRoleBelong">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  getPowerByRoleId,
  grantMenu,
  getUserByRole,
  getSystemUserList,
  setUsersRole,
  deleteRoles,
} from "@/api/index";
export default {
  data() {
    return {
      filterText: "",
      data: [],
      roleId: 0,
      activeName: "power",
      powerTree: [],
      dataList: [],
      userList: [],
      userListForFilter: [],
      actLogList: [],
      userInRoleData: {
        ifShow: false,
        users: [],
        roleId: 0,
        inputVisible: false,
        inputValue: "",
        searchText: "",
      },
      roleData: {},
      ifLoading: false,
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    },
  },
  created() {},
  mounted() {
    this.roleId = this.$route.query.id;
    this.roleData = this.$route.query;
    this.getData();
    getSystemUserList({ pageNumber: 1, pageSize: 1000, departmentId: 0 }).then(
      (data) => {
        this.userListForFilter = data.rows;
      }
    );
  },
  methods: {
    editUserByRole(role) {
      this.ifLoading = true;
      getUserByRole({ roleId: role.id }).then((data) => {
        this.userInRoleData.users = data;
        Object.assign(this.userInRoleData, role);
        this.userInRoleData.ifShow = true;
        this.userInRoleData.inputVisible = false;
        this.ifLoading = false;
      });
    },
    userInputSearch(queryString, cb) {
      var userListForFilter = this.userListForFilter;
      var results = queryString
        ? userListForFilter.filter(
            (obj) => obj.userName.toLowerCase().indexOf(queryString) > -1
          )
        : userListForFilter;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleInputConfirm(value) {
      if (value) {
        this.userInRoleData.users.push(value);
      }
      this.userInRoleData.inputVisible = false;
      this.userInRoleData.searchText = "";
    },
    handleClose(tag) {
      this.userInRoleData.users.splice(
        this.userInRoleData.users.indexOf(tag),
        1
      );
    },
    submitRoleBelong() {
      this.userInRoleData.userIds = this.userInRoleData.users.map(
        (item) => item.id
      );
      setUsersRole(this.userInRoleData).then((data) => {
        this.$message.success(data);
        this.userInRoleData.ifShow = false;
        this.getData();
      });
    },
    showInput() {
      this.userInRoleData.searchText = "";
      this.userInRoleData.inputVisible = true;
      this.$nextTick((_) => {
        this.$refs.saveTagInput.$refs.input.focus();
      });
    },
    getData() {
      this.ifLoading = true;

      switch (this.activeName) {
        case "power":
          getPowerByRoleId({ roleId: this.$route.query.id }).then((data) => {
            this.powerTree = data;
            let checkedNodes = data.reduce(calcCheckNodes, []);

            this.$refs.tree.setCheckedKeys(checkedNodes, true);
            this.ifLoading = false;
          });

          break;
        case "users":
          getUserByRole({ roleId: this.roleId }).then((data) => {
            this.userList = data;
            this.ifLoading = false;
          });
          break;
        case "actLog":
          break;
        default:
          break;
      }
    },
    submitPower() {
      grantMenu({
        roleId: this.roleId,
        // menuIds: this.$refs.tree.getCheckedKeys(true),
        menuIds: this.$refs.tree
          .getHalfCheckedKeys()
          .concat(this.$refs.tree.getCheckedKeys()),
      }).then((data) => {
        this.$message.success("保存成功");
      });
    },
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    deleteRole() {
      this.$confirm(`确认删除吗`, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then((data) => {
        deleteRoles({ roleIds: [this.roleData.id] }).then((data) => {
          this.$message.success("删除成功");
          this.$router.go(-1);
          this.getData();
        });
      });
    },
  },
};

function calcCheckNodes(total, current, idx, arr) {
  if (current.checked && current.parentId != 0) {
    total.push(current.id);
  }
  if (current.children && current.children.length > 0) {
    current.children.reduce(calcCheckNodes, total);
  }
  return total;
}
</script>

<style scoped lang="less">
.wrapper {
  background: #fff;
  padding: 30px 0;
  min-height: 800px;
  .contentContainer {
    border: 1px solid #ccc;
    width: 70%;
    margin: 30px auto;
    padding: 20px;
    .treeContainer {
      padding: 20px 15%;
    }
    .totalDescribe {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .describe {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
        .el-icon-user-solid {
          font-size: 36px;
          color: #fff;
          padding: 10px;
          background: orange;
          border-radius: 50%;
          margin-right: 20px;
        }
        .name {
          font-size: 14px;
          strong {
            font-size: 18px;
          }
        }
      }
      .actSide {
      }
    }
  }
}
.el-tag + .el-tag {
  margin-left: 10px;
}
.button-new-tag {
  margin-left: 10px;
  height: 32px;
  line-height: 30px;
  padding-top: 0;
  padding-bottom: 0;
}
.input-new-tag {
  width: 90px;
  margin-left: 10px;
  vertical-align: bottom;
}
</style>
